export const CINEMA_TYPE = {
    DEFAULT: 'default',
    DELUXE: 'deluxe',
    GOLD_CLASS: 'gold-class',
    CSFD: 'csfd',
    BOUTIQUE: 'boutique-cinema',
}

export const CINEMA_TYPE_PROPERTY = {
    DELUXE: 'TDL',
    DELUXE_FAMILY: 'TDL Family',
    GOLD_CLASS: 'Gold Class',
    CSFD: 'Sál ČSFD.cz',
    BOUTIQUE: 'Boutique cinema',
}

export const SEAT_OBJECT_KEYS = [
    'ticketid',
    'state',
    'seatid',
    'price_categoryid',
    'group_seatid',
    'row',
    'seat',
    'x1',
    'y1',
    'x2',
    'y2',
    'rotation',
]
